
      document.addEventListener('DOMContentLoaded', function () {
        if (typeof recharge !== 'undefined') {
          recharge.init({
            storeIdentifier: '',
            storefrontAccessToken: 'strfnt_ffac5537f01e5059650df5c8f6c1d3996ff55467af7ba14f5c2370ee9186d17c',
            loginRetryFn: () => {
              return recharge.auth.loginShopifyAppProxy().then((session) => {
                return session;
              });
            },
          });
        }
      });
      
      
      window.abTesting = {}
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
      let value = params.ab;
      
      
      
      // (function() {
      //   // Fixed: Largest Contentful Paint image was lazily loaded
      //   const first_image = document.querySelector('#MainContent .shopify-section .media img');
      //   if (first_image) first_image.setAttribute('loading', 'eager');
      // })();

      window.onerror = function myErrorHandler(errorMsg, url, lineNumber) {
        return false;
      };
      document.addEventListener('DOMContentLoaded', function () {
        setTimeout(function () {
          let b_reviewAddButtonAriaExpanded = 'false';
          let cancel_button_setup = false;
          const b_reviewAddButton = document.querySelector('.jdgm-write-rev-link');
          if (b_reviewAddButton) {
            b_reviewAddButton.removeAttribute('href');
            b_reviewAddButton.addEventListener('click', function () {
              setTimeout(function () {
                if (!cancel_button_setup) {
                  const jdgm_cancel_rev = document.querySelector('.jdgm-cancel-rev');
                  if (jdgm_cancel_rev) {
                    cancel_button_setup = true;
                    jdgm_cancel_rev.addEventListener('click', function () {
                      setTimeout(function () {
                        if (b_reviewAddButtonAriaExpanded === b_reviewAddButton.getAttribute('aria-expanded')) {
                          b_reviewAddButton.click();
                        } else {
                          b_reviewAddButtonAriaExpanded = b_reviewAddButton.getAttribute('aria-expanded');
                        }
                      }, 500);
                    });
                  }
                }
                if (b_reviewAddButtonAriaExpanded === b_reviewAddButton.getAttribute('aria-expanded')) {
                  if (b_reviewAddButton.classList.contains('close-form-btn')) {
                    b_reviewAddButton.classList.remove('close-form-btn');
                    b_reviewAddButton.innerHTML = 'Write a review';
                    b_reviewAddButton.setAttribute('aria-expanded', false);
                    const b_reviewForm = document.querySelector('.jdgm-form-wrapper');
                    if (b_reviewForm) b_reviewForm.style.display = 'none';
                  } else {
                    b_reviewAddButton.classList.add('close-form-btn');
                    b_reviewAddButton.innerHTML = 'Cancel review';
                    b_reviewAddButton.setAttribute('aria-expanded', true);
                    const b_reviewForm = document.querySelector('.jdgm-form-wrapper');
                    if (b_reviewForm) b_reviewForm.style.display = 'block';
                  }
                }
                b_reviewAddButtonAriaExpanded = b_reviewAddButton.getAttribute('aria-expanded');
              }, 1000);
            });
            const writeReview = new URLSearchParams(window.location.search);
            const writeReviewValue = writeReview.get('write-review');
            if (writeReviewValue === 'true') {
              b_reviewAddButton.click();
              let attempts = 0;
              const maxAttempts = 50; // Maximum number of attempts (each attempt is 100ms)
              const intervalTime = 100; // Interval time in milliseconds
              const interval = setInterval(function () {
                const inputField = document.querySelector('.jdgm-form__fieldset>input');
                if (inputField) {
                  clearInterval(interval); // Stop the interval
                  setTimeout(() => {
                    document.querySelector('.jdgm-form__fieldset>input').focus(); // Focus on the input field
                    document
                      .querySelector('.jdgm-form__fieldset>input')
                      .scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' }); // Scroll the input field into view
                  }, 1000);
                } else {
                  attempts++;
                  if (attempts >= maxAttempts) {
                    clearInterval(interval); // Stop the interval after maximum attempts
                  }
                }
              }, intervalTime);
            }
          }
        }, 3000);
      });

      _linkedin_partner_id = '5898986';
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(_linkedin_partner_id);

      (function (l) {
        if (!l) {
          window.lintrk = function (a, b) {
            window.lintrk.q.push([a, b]);
          };
          window.lintrk.q = [];
        }
        var s = document.getElementsByTagName('script')[0];
        var b = document.createElement('script');
        b.type = 'text/javascript';
        b.async = true;
        b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
        s.parentNode.insertBefore(b, s);
      })(window.lintrk);

      document.getElementById('showProducttocart').addEventListener('click', someFunction);
      
      function someFunction(event) {
        let cartDrawerEl = document.querySelector('cart-drawer');
        cartDrawerEl.querySelector('summary').click();
        let notificationElement = document.getElementById('showProducttocart');
        notificationElement.classList.remove('active');
      }
      function closeProducttocartf() {
        document.body.click();
      }
